import { render, staticRenderFns } from "./fotofilm.vue?vue&type=template&id=3aed8d2c&"
import script from "./fotofilm.vue?vue&type=script&lang=js&"
export * from "./fotofilm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports